import type { FC } from 'react';
import { Inline, Paragraph } from '@george-labs.com/design-system';

interface Props {
    subtitle: string;
    'data-cy'?: string;
}

export const ProductSubtitle: FC<Props> = ({ subtitle, 'data-cy': dataCy }) => (
    <Paragraph className="text-white pt-0" data-cy={dataCy}>
        <Inline className="fontSize18" emphasis>
            {subtitle}
        </Inline>
    </Paragraph>
);
